export default __webpack_public_path__ + "static/realWorldImg3-efe0667def2b1ab495327470fe32f836.png";